import { observer } from 'mobx-react-lite'
import React from 'react'
import { IconButton } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useBroadcastDetailOneTimeContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/context/context'
import styles from './styles.module.scss'

export const BroadcastContactStatisticsSearch = observer(() => {
  const { search, setSearch } = useBroadcastDetailOneTimeContext()
  return (
    <div className={styles.search}>
      <IconButton
        icon='search'
        size={'medium'}
        variant={'icon'}
        color={'secondary'}
        ariaLabel={'search'}
      />
      <TextField
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
        }}
        onChange={setSearch}
        value={search || ''}
      />
    </div>
  )
})
